import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';
export {Navigation, Thumbs, Pagination, Autoplay, FreeMode} from 'swiper/modules';
export {Swiper, SwiperSlide} from 'swiper/react';
export type {SwiperOptions} from 'swiper/types';
